import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export default function RequireNoAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return null;

  const params = new URLSearchParams(location.search);
  const redirect = params.get('redirect') || location.state?.from?.pathname;

  // Allow login/signup if the redirect points to an invite flow.
  const isInviteRedirect =
    typeof redirect === 'string' &&
    (redirect.startsWith('/invite/') ||
      redirect.startsWith('/org-invite/') ||
      redirect.startsWith('/customer-subuser-invite/'));

  // Normal behavior: if logged in, send to dashboard — EXCEPT when handling an invite.
  return user && !isInviteRedirect ? <Navigate to="/settings" replace /> : <Outlet />;
}

export function HomeGate() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return <Navigate to={user ? '/settings' : '/login'} replace />;
}
